import React from 'react';

import Button from 'common/components/Button';
import { LocalStorageKeys } from 'common/constants/LocalStorageKeys';
import { TrackingEventNames } from 'common/constants/trackingEventsNames';
import { ModalNames } from 'common/module/ui/lazy-modal/constant-types';
import buildReactDomModalModule from 'common/module/ui/lazy-modal/react-dom-modal-module';
import ReactModal from 'common/module/ui/lazy-modal/react-modal';
import {
  CloseModal,
  PromoteSignupModalParams
} from 'common/module/ui/lazy-modal/types';
import eventEmitter from 'common/services/events/eventEmitter';
import { path } from 'common/tools/network/routing';
import trans from 'common/tools/translations/trans';
import { setCapping } from 'common/tools/ui/capping-helper';
import { getSignUpUrl } from 'common/tools/userspace';

import styles from './styles.module.scss';

type Props = { closeModal: CloseModal };

const PromoteSignupModal = ({
  figure,
  poster,
  text,
  closeModal
}: Props & PromoteSignupModalParams) => {
  return (
    <ReactModal
      backgroundImage={poster}
      className={styles.modal}
      size="large"
      title={trans('promote-signup-modal.title')}
    >
      <p className={styles.text}>{text}</p>
      <img className={styles.img} src={figure} />
      <Button
        theme="inverse"
        href={getSignUpUrl(path('userspace'))}
        onClick={() => {
          setCapping(LocalStorageKeys.PROMOTE_SIGNUP_MODAL_CAPPING);

          eventEmitter.emit(TrackingEventNames.PROMOTE_SIGNUP_CLICK);
          closeModal();
        }}
      >
        {trans('promote-signup-modal.cta')}
      </Button>
    </ReactModal>
  );
};

export default buildReactDomModalModule(
  ModalNames.PROMOTE_SIGNUP,
  (params: PromoteSignupModalParams, closeModal: CloseModal) => {
    return <PromoteSignupModal closeModal={closeModal} {...params} />;
  },
  () => {
    setCapping(LocalStorageKeys.PROMOTE_SIGNUP_MODAL_CAPPING);
  }
);
